module.exports = __webpack_public_path__ + "f71549ef1a7b196fc0848b1ad527c751.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-0.png
// module id = 3132
// module chunks = 0